if (!customElements.get('made-in-india-badge')) {
  class MadeInIndiaBadge extends HTMLElement {
    constructor() {
      super();
      this.text = null;
      this.path = null;
      this.fit = this.fit.bind(this);
    }

    connectedCallback() {
      this.text = this.querySelector('.made-in-india__ring-text');
      this.path = this.querySelector('textPath');
      if (!this.text || !this.path) return;

      this.fit();
      if (document.fonts) {
        document.fonts.ready.then(this.fit);
        document.fonts.addEventListener('loadingdone', this.fit);
      }
    }

    disconnectedCallback() {
      if (document.fonts) document.fonts.removeEventListener('loadingdone', this.fit);
    }

    /*
     * Safari and Firefox ignore textLength on text-on-a-path, so the spacing is measured and set here instead.
     * Short text is spread out to fill the circle; text that is too long for the circle is shrunk to fit it.
     */
    fit() {
      const target = Number(this.dataset.ringLength);
      const count = this.path.textContent.length;
      if (!target || !count) return;

      this.text.style.fontSize = '';
      this.text.style.letterSpacing = '0px';
      const natural = this.path.getComputedTextLength();
      if (!natural) {
        this.text.style.letterSpacing = '';
        return;
      }

      if (natural > target) {
        const baseSize = parseFloat(window.getComputedStyle(this.text).fontSize);
        this.text.style.fontSize = `${(baseSize * target * 0.99) / natural}px`;
        return;
      }

      this.text.style.letterSpacing = `${(target - natural) / count}px`;
    }
  }

  customElements.define('made-in-india-badge', MadeInIndiaBadge);
}
